import Cookies from 'js-cookie';
import axios from 'axios';

export const getCookie = key => {
    let result = Cookies.get(key);
    if (result && result.length > 0) {
        return result;
    }
    return "";
};

export const removeCookie = key => {
    Cookies.remove(key);
}

export const isLogin = () => {
    let headimage = getCookie('headimage');
    let nickname = getCookie('nickname');
    let unionId = getCookie('unionId');
    if (headimage && headimage.length > 0 && nickname && nickname.length > 0 && unionId && unionId.length > 0) {
        // 已登录
        return true
    } else {
        // 未登录
        return false
    }
}

// 是否注册
export const isRegister = () => {
    console.log(`--- router isRegister`)
    let unionId = getCookie('unionId');
    axios.get(`https://home.51point.com/51point-0.0.1-SNAPSHOT/mdz/ck?param=${unionId}`)
        .then(res => {
            console.log(`---- ck`)
            console.log(res)
            if (res.data.code == 1 && res.data.data.ib == 1) {
                return true;
            } else {
                return false;
            }
        })
        .catch(() => {
            return false;
        })
}

// 是否开通
export const isOpen = () => {
    return true;
}

// 验证手机号
export const isPhone = (phone) => {
    console.log(`--- phone = ${phone}`)
    if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/.test(phone))) {
        return false;
    } else {
        return true;
    }
}